/**
 * Utilitário para gerenciar permissões do Safe Spot
 * Armazena e recupera a permissão do Safe Spot no localStorage
 */

const SAFE_SPOT_PERMISSION_KEY = 'isSafeSpot'

/**
 * Salva a permissão do Safe Spot no localStorage
 * @param {boolean} isSafeSpot - True se o usuário tem permissão para Safe Spot
 */
export const setSafeSpotPermission = (isSafeSpot) => {
  localStorage.setItem(SAFE_SPOT_PERMISSION_KEY, JSON.stringify(isSafeSpot))
}

/**
 * Recupera a permissão do Safe Spot do localStorage
 * @returns {boolean|null} - True/False se definido, null se não existir
 */
export const getSafeSpotPermission = () => {
  const value = localStorage.getItem(SAFE_SPOT_PERMISSION_KEY)
  return value !== null ? JSON.parse(value) : null
}

/**
 * Remove a permissão do Safe Spot do localStorage
 * Útil para limpar ao fazer logout
 */
export const clearSafeSpotPermission = () => {
  localStorage.removeItem(SAFE_SPOT_PERMISSION_KEY)
}

/**
 * Verifica se o usuário tem permissão para Safe Spot
 * @returns {boolean} - True se tem permissão, false caso contrário
 */
export const hasSafeSpotPermission = () => {
  const permission = getSafeSpotPermission()
  return permission === true
}

